import { toMathRound } from '../../../utils/to-math-round.util';
import { toNumber } from '../../../utils/to-number.util';

const CAP_TABLE_TEXT_COLUMNS = new Set(['name', 'stakeholder-name', 'type']);

export const isCapTableTextColumn = (field: string): boolean => CAP_TABLE_TEXT_COLUMNS.has(field);

export const formatScenarioCapTableCellValue = (
  field: string,
  value: null | number | string | undefined,
): string => {
  if (value === null || value === undefined) {
    return '-';
  }

  if (isCapTableTextColumn(field)) {
    return String(value);
  }

  if (value === '-') {
    return '-';
  }

  const numericValue = toNumber(value);
  if (numericValue === 0) {
    return '-';
  }

  if (typeof value === 'number' || !Number.isNaN(numericValue)) {
    return toMathRound(numericValue)?.toLocaleString('en-US') ?? '-';
  }

  return String(value);
};

export const isCapTableEmptyDisplayValue = (displayValue: string): boolean => displayValue === '-';
